import React, { useContext, useState } from "react";
import {
  PermisosAcademico,
  PermisosAdministrativo,
  PermisosAdmin,
} from "../Authentication/Permisos";
import { MenuContext } from "../Utils/MenuContext";

export default function SideBar(props) {
  // const context = useContext(AuthContext);
  const menu = useContext(MenuContext);
  const [active, setActive] = useState("");

  return (
    <aside className="aside aside-fixed">
      <div className="aside-header">
        <a
          href="#"
          className="aside-logo"
          onClick={() => {
            setActive("");
            menu.linkNav("home", "", "inicio");
          }}
        >
          <img
            src={require("../../assets/img/iunir_logo_mini.png")}
            alt="IUNIR"
          />
        </a>
        {/* <a href="../../index.html" className="aside-logo">
          I<span>UN</span>IR
        </a> */}
        <a href="" className="aside-menu-link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          {/* <i data-feather="menu"></i>
          <i data-feather="x"></i> */}
        </a>
      </div>
      <div className="aside-body scroll-bar overflow-x-none">
        <ul className="nav nav-aside">
          <li className="nav-label">General</li>
          <li
            className={
              active === "institucion" ? "nav-item active" : "nav-item"
            }
          >
            <a
              href="#"
              className="nav-link"
              onClick={() => {
                menu.linkNav("institucion", "", "institucion");
                setActive("institucion");
              }}
            >
              {/* <i data-feather="layers"></i> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 28 28"
                width="20"
                height="20"
                stroke="currentColor"
                fill="currentColor"
              >
                <g
                  id="g9120"
                  strokeWidth="20"
                  transform="matrix(0.04687491,0,0,0.05258482,2.7105289e-5,-1.4617265)"
                >
                  <g id="g9118">
                    <path d="M 506.555,208.064 263.859,30.367 c -4.68,-3.426 -11.038,-3.426 -15.716,0 L 5.445,208.064 c -5.928,4.341 -7.216,12.665 -2.875,18.593 4.341,5.928 12.666,7.214 18.593,2.875 L 256,57.588 490.837,229.531 c 2.368,1.735 5.12,2.57 7.848,2.57 4.096,0 8.138,-1.885 10.744,-5.445 4.342,-5.927 3.054,-14.251 -2.874,-18.592 z" />
                  </g>
                </g>
                <g
                  id="g9126"
                  strokeWidth="20"
                  transform="matrix(0.04687491,0,0,0.05258482,2.7105289e-5,-1.4617265)"
                >
                  <g id="g9124">
                    <path d="m 442.246,232.543 c -7.346,0 -13.303,5.956 -13.303,13.303 V 457.595 H 322.521 V 342.009 c 0,-36.68 -29.842,-66.52 -66.52,-66.52 -36.678,0 -66.52,29.842 -66.52,66.52 V 457.596 H 83.058 V 245.847 c 0,-7.347 -5.957,-13.303 -13.303,-13.303 -7.346,0 -13.303,5.956 -13.303,13.303 V 470.9 c 0,7.347 5.957,13.303 13.303,13.303 h 133.029 c 6.996,0 12.721,-5.405 13.251,-12.267 0.032,-0.311 0.052,-0.651 0.052,-1.036 V 342.01 c 0,-22.009 17.905,-39.914 39.914,-39.914 22.009,0 39.914,17.906 39.914,39.914 V 470.9 c 0,0.383 0.02,0.717 0.052,1.024 0.524,6.867 6.251,12.279 13.251,12.279 h 133.029 c 7.347,0 13.303,-5.956 13.303,-13.303 V 245.847 c -0.001,-7.348 -5.957,-13.304 -13.304,-13.304 z" />
                  </g>
                </g>
              </svg>
              <span>Institución</span>
            </a>
          </li>
          <PermisosAdmin>
            <li
              className={active === "admin" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("admin", "", "admin");
                  setActive("admin");
                }}
              >
                {/* <i data-feather="user"></i> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-settings">
                  <circle cx="12" cy="12" r="3">
                  </circle>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                  </path>
                  </svg>
                <span>Admin</span>
              </a>
            </li>
            </PermisosAdmin>
          {/* <PermisosAcademico> */}
          <>
            <li className="nav-label mg-t-25">Académico</li>
            <li
              className={active === "carreras" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("carreras", "", "carreras");
                  setActive("carreras");
                }}
              >
                {/* <i data-feather="layers"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 22 22"
                  fill="currentColor"
                >
                  <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z" />
                </svg>
                <span>Carreras</span>
              </a>
            </li>
            <li
              className={active === "materias" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("materias", "", "cursado");
                  setActive("materias");
                }}
              >
                {/* <i data-feather="layers"></i> */}
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  fill="none"
                >
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>

                <span>Cursado</span>
              </a>
            </li>
            <li
              className={active === "examen" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("examenes", "", "Exámenes");
                  setActive("examen");
                }}
              >
                {/* <i data-feather="layers"></i> */}
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  fill="none"
                >
                  <line x1="22" y1="12" x2="2" y2="12"></line>
                  <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
                  <line x1="6" y1="16" x2="6.01" y2="16"></line>
                  <line x1="10" y1="16" x2="10.01" y2="16"></line>
                </svg>

                <span>Exámenes</span>
              </a>
            </li>
            <li
              className={active === "docentes" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("docentes", "", "docentes");
                  setActive("docentes");
                }}
              >
                {/* <i data-feather="user"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  fill="currentColor"
                >
                  <path
                    strokeWidth="0.5"
                    d="M 22.460095,14.923514 C 20.997641,13.722855 19.440398,12.847191 18.69563,12.454491 v -1.913826 c 0.361099,-0.379152 0.564218,-0.889212 0.564218,-1.4218325 V 6.3157942 c 0,-1.8416017 -1.498564,-3.3401684 -3.340172,-3.3401684 h -0.600329 c -1.841608,0 -3.340172,1.4985667 -3.340172,3.3401684 v 2.8030383 c 0,0.5371395 0.203119,1.0426805 0.564219,1.4218325 v 1.913826 c -0.744769,0.3927 -2.306525,1.268364 -3.764465,2.469023 -0.501026,0.415259 -0.789905,1.024623 -0.789905,1.679113 v 4.567906 H 2.8749484 v -4.211322 c 0,-0.09029 0.040627,-0.171518 0.1038162,-0.225684 1.3496102,-1.110385 2.8120638,-1.84612 3.0919167,-1.98154 0.3114485,-0.153468 0.5145671,-0.473944 0.5145671,-0.821498 v -2.202713 c 0,-0.27082 -0.1354127,-0.523591 -0.3610997,-0.677059 -0.031598,-0.01806 -0.099302,-0.07672 -0.099302,-0.180547 V 8.5862125 c 0,-0.6860883 0.5597047,-1.2457958 1.2457943,-1.2457958 h 0.491998 c 0.68609,0 1.245794,0.5597075 1.245794,1.2457958 V 10.87017 c 0,0.103813 -0.06771,0.162498 -0.0993,0.180547 -0.374641,0.248261 -0.473944,0.753793 -0.225687,1.128435 0.248256,0.374641 0.753796,0.473944 1.128436,0.225692 0.514568,-0.343044 0.821502,-0.916291 0.821502,-1.534674 V 8.5862125 c 0,-1.5843208 -1.286417,-2.8707433 -2.870743,-2.8707433 H 7.37064 c -1.5843252,0 -2.8707422,1.2864225 -2.8707422,2.8707433 V 10.87017 c 0,0.455886 0.1670084,0.884693 0.4604013,1.218708 v 1.408294 C 4.3193474,13.831187 3.0961227,14.530814 1.9496303,15.478702 1.5072836,15.844315 1.25,16.385964 1.25,16.96373 v 5.023792 C 1.25,22.434387 1.6156134,22.8 2.0624747,22.8 H 8.801497 c 0.446862,0 0.812475,-0.365613 0.812475,-0.812478 v -5.384895 c 0,-0.167007 0.07221,-0.320475 0.198605,-0.424297 1.670086,-1.372177 3.484612,-2.288467 3.832171,-2.459985 0.320476,-0.157987 0.523594,-0.487483 0.523594,-0.844076 v -2.703736 c 0,-0.27082 -0.135412,-0.52359 -0.3611,-0.6770588 -0.126384,-0.0858 -0.203118,-0.2256834 -0.203118,-0.3746417 V 6.3157942 c 0,-0.9433692 0.767337,-1.7152209 1.715223,-1.7152209 h 0.604843 c 0.943373,0 1.715223,0.7673417 1.715223,1.7152209 v 2.8030383 c 0,0.1489583 -0.07673,0.2933975 -0.203118,0.3746417 -0.225687,0.1489578 -0.3611,0.4062388 -0.3611,0.6770588 v 2.703736 c 0,0.356593 0.207632,0.686088 0.523594,0.844076 0.347559,0.171518 2.162085,1.083298 3.832171,2.459985 0.126385,0.103822 0.198605,0.25729 0.198605,0.424297 v 4.567906 H 12.25 c -0.446861,0 -0.812475,0.365622 -0.812475,0.812479 0,0.446856 0.365614,0.812478 0.812475,0.812478 h 10.187525 c 0.446862,0 0.812475,-0.365622 0.812475,-0.812478 v -5.380384 c 0,-0.654491 -0.28888,-1.263855 -0.789905,-1.679114 z"
                  />
                  {/* <g
                  xmlns="http://www.w3.org/2000/svg"
                  id="g95"
                  transform="matrix(0.04924087,0,0,0.04924087,0,1.086715)"
                >
                  <path d="m 469.9,288.8 c -32.4,-26.6 -66.9,-46 -83.4,-54.7 v -42.4 c 8,-8.4 12.5,-19.7 12.5,-31.5 V 98.1 c 0,-40.8 -33.2,-74 -74,-74 h -13.3 c -40.8,0 -74,33.2 -74,74 v 62.1 c 0,11.9 4.5,23.1 12.5,31.5 v 42.4 c -16.5,8.7 -51.1,28.1 -83.4,54.7 -11.1,9.2 -17.5,22.7 -17.5,37.2 V 427.2 H 36 v -93.3 c 0,-2 0.9,-3.8 2.3,-5 29.9,-24.6 62.3,-40.9 68.5,-43.9 6.9,-3.4 11.4,-10.5 11.4,-18.2 V 218 c 0,-6 -3,-11.6 -8,-15 -0.7,-0.4 -2.2,-1.7 -2.2,-4 v -50.6 c 0,-15.2 12.4,-27.6 27.6,-27.6 h 10.9 c 15.2,0 27.6,12.4 27.6,27.6 V 199 c 0,2.3 -1.5,3.6 -2.2,4 -8.3,5.5 -10.5,16.7 -5,25 5.5,8.3 16.7,10.5 25,5 11.4,-7.6 18.2,-20.3 18.2,-34 v -50.6 c 0,-35.1 -28.5,-63.6 -63.6,-63.6 H 135.6 C 100.5,84.8 72,113.3 72,148.4 V 199 c 0,10.1 3.7,19.6 10.2,27 v 31.2 C 68,264.6 40.9,280.1 15.5,301.1 5.7,309.2 0,321.2 0,334 v 111.3 c 0,9.9 8.1,18 18,18 h 149.3 c 9.9,0 18,-8.1 18,-18 V 326 c 0,-3.7 1.6,-7.1 4.4,-9.4 37,-30.4 77.2,-50.7 84.9,-54.5 7.1,-3.5 11.6,-10.8 11.6,-18.7 v -59.9 c 0,-6 -3,-11.6 -8,-15 -2.8,-1.9 -4.5,-5 -4.5,-8.3 V 98.1 c 0,-20.9 17,-38 38,-38 h 13.4 c 20.9,0 38,17 38,38 v 62.1 c 0,3.3 -1.7,6.5 -4.5,8.3 -5,3.3 -8,9 -8,15 v 59.9 c 0,7.9 4.6,15.2 11.6,18.7 7.7,3.8 47.9,24 84.9,54.5 2.8,2.3 4.4,5.7 4.4,9.4 V 427.2 H 243.7 c -9.9,0 -18,8.1 -18,18 0,9.9 8.1,18 18,18 h 225.7 c 9.9,0 18,-8.1 18,-18 V 326 c 0,-14.5 -6.4,-28 -17.5,-37.2 z" />
                </g> */}
                  {/* <path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /> */}
                </svg>
                <span>Docentes</span>
              </a>
            </li>
            <li
              className={active === "alumnos" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("alumnos", "", "alumnos");
                  setActive("alumnos");
                }}
              >
                {/* <i data-feather="user"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 22 22"
                  fill="currentColor" //fill="rgba(27, 46, 75, 0.65)"
                >
                  <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z" />
                </svg>
                <span>Alumnos</span>
              </a>
            </li>
            <li
              className={active === "reportes" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("reportes", "", "reportes");
                  setActive("reportes");
                }}
              >
                {/* <i data-feather="user"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 22 22"
                  fill="currentColor" //fill="rgba(27, 46, 75, 0.65)"
                >
                  <path d="M 5.54 8.328 C 4.943 8.328 4.461 7.761 4.461 7.058 C 4.461 6.356 4.943 5.791 5.54 5.791 C 6.138 5.791 6.622 6.356 6.622 7.058 C 6.622 7.761 6.138 8.328 5.54 8.328 Z M 7.974 7.058 C 7.974 6.53 8.335 6.107 8.784 6.107 L 16.356 6.107 C 16.807 6.107 17.169 6.53 17.169 7.058 C 17.169 7.587 16.807 8.013 16.356 8.013 L 8.784 8.013 C 8.335 8.013 7.974 7.587 7.974 7.058 Z M 7.974 10.869 C 7.974 10.341 8.335 9.915 8.784 9.915 L 16.356 9.915 C 16.807 9.915 17.169 10.341 17.169 10.869 C 17.169 11.397 16.807 11.821 16.356 11.821 L 8.784 11.821 C 8.335 11.821 7.974 11.397 7.974 10.869 Z M 7.974 14.68 C 7.974 14.152 8.335 13.727 8.784 13.727 L 16.356 13.727 C 16.807 13.727 17.169 14.152 17.169 14.68 C 17.169 15.208 16.807 15.631 16.356 15.631 L 8.784 15.631 C 8.335 15.631 7.974 15.208 7.974 14.68 Z M 5.54 9.601 C 6.138 9.601 6.622 10.167 6.622 10.869 C 6.622 11.573 6.138 12.138 5.54 12.138 C 4.943 12.138 4.461 11.573 4.461 10.869 C 4.461 10.167 4.943 9.601 5.54 9.601 Z M 5.54 15.949 C 4.943 15.949 4.461 15.382 4.461 14.68 C 4.461 13.976 4.943 13.409 5.54 13.409 C 6.138 13.409 6.622 13.976 6.622 14.68 C 6.622 15.382 6.138 15.949 5.54 15.949 Z M 1.214 4.52 C 1.214 3.117 2.182 1.979 3.378 1.979 L 18.52 1.979 C 19.712 1.979 20.683 3.117 20.683 4.52 L 20.683 17.22 C 20.683 18.62 19.712 19.76 18.52 19.76 L 3.378 19.76 C 2.182 19.76 1.214 18.62 1.214 17.22 L 1.214 4.52 Z M 2.837 4.52 L 2.837 17.22 C 2.837 17.568 3.078 17.854 3.378 17.854 L 18.52 17.854 C 18.817 17.854 19.059 17.568 19.059 17.22 L 19.059 4.52 C 19.059 4.168 18.817 3.885 18.52 3.885 L 3.378 3.885 C 3.078 3.885 2.837 4.168 2.837 4.52 Z" />
                </svg>
                <span>Reportes</span>
              </a>
            </li>
            <li
              className={active === "inscripciones" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("inscripciones", "", "inscripciones");
                  setActive("inscripciones");
                }}
              >
                {/* <i data-feather="user"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  stroke="currentColor"
                  fill="currentColor" //fill="rgba(27, 46, 75, 0.65)"
                >
                  <path
                  strokeWidth="0.5"
                  d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                </svg>
                <span>Inscripciones</span>
              </a>
            </li>
            <PermisosAdmin>
              <>
                <li
                  className={
                    active === "extension" ? "nav-item active" : "nav-item"
                  }
                >
                  <a
                    href="#"
                    className="nav-link"
                    onClick={() => {
                      menu.linkNav("extension", "", "extension");
                      setActive("extension");
                    }}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      stroke="currentColor"
                    >
                      <circle fill="none" cx="18" cy="5" r="3"></circle>
                      <circle fill="none" cx="6" cy="12" r="3"></circle>
                      <circle fill="none" cx="18" cy="19" r="3"></circle>
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                    </svg>
                    <span>Extensión</span>
                  </a>
                </li>
                <li
                  className={
                    active === "investigacion" ? "nav-item active" : "nav-item"
                  }
                >
                  <a
                    href="#"
                    className="nav-link"
                    onClick={() => {
                      menu.linkNav("investigacion", "", "investigacion");
                      setActive("investigacion");
                    }}
                  >
                    {/* <i data-feather="user"></i> */}
                    <svg
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      stroke="currentColor"
                    >
                      <path
                        fill="none"
                        d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
                      ></path>
                      <path
                        fill="none"
                        d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
                      ></path>
                    </svg>
                    <span>Investigación</span>
                  </a>
                </li>
                <li
                  className={
                    active === "cursos" ? "nav-item active" : "nav-item"
                  }
                >
                  <a
                    href="#"
                    className="nav-link"
                    onClick={() => {
                      menu.linkNav("cursos", "", "cursos");
                      setActive("cursos");
                    }}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      stroke="currentColor"
                    >
                      <path
                        fill="none"
                        d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
                      ></path>
                      <polygon
                        fill="none"
                        points="12 15 17 21 7 21 12 15"
                      ></polygon>
                    </svg>
                    <span>Cursos</span>
                  </a>
                </li>
              </>
            </PermisosAdmin>
            <li className="nav-label mg-t-25">Ayuda</li>
            <li
              className={
                active === "tutoriales" ? "nav-item active" : "nav-item"
              }
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("tutoriales", "", "tutoriales");
                  setActive("tutoriales");
                }}
              >
                {/* <i className="far fa-life-ring"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 28 28"
                  width="20"
                  height="20"
                  stroke="currentColor"
                  fill="none"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="4"></circle>
                  <line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
                  <line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
                  <line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
                  <line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line>
                  <line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
                </svg>
                <span>Tutoriales</span>
              </a>
            </li>
            {/* <PermisosAdmin> */}
            <li
              className={active === "tickets" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("tickets", "", "tickets");
                  setActive("tickets");
                }}
              >
                {/* <i className="far fa-life-ring"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 28 28"
                  width="20"
                  height="20"
                  stroke="currentColor"
                  fill="none"
                >
                  <path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>
                </svg>
                <span>Tickets</span>
              </a>
            </li>
            {/* </PermisosAdmin> */}
            <li className="nav-label mg-t-25">G.A.D.I</li>
            <li
              className={active === "archivos" ? "nav-item active" : "nav-item"}
            >
              <a
                href="#"
                className="nav-link"
                onClick={() => {
                  menu.linkNav("archivos", "", "Archivos");
                  setActive("archivos");
                }}
              >
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                >
                  <path
                    fill="none"
                    d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                  ></path>
                </svg>
                <span>Archivos</span>
              </a>
            </li>
            <PermisosAdmin>
              <li
                className={
                  active === "expedientes" ? "nav-item active" : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("expedientes", "", "Sistema de Expedientes");
                    setActive("expedientes");
                  }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                  >
                    <path
                      fill="none"
                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                    ></path>
                    <polyline fill="none" points="14 2 14 8 20 8"></polyline>
                    <line fill="none" x1="16" y1="13" x2="8" y2="13"></line>
                    <line fill="none" x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline fill="none" points="10 9 9 9 8 9"></polyline>
                  </svg>
                  <span>Expedientes</span>
                </a>
              </li>
            </PermisosAdmin>
          </>
          {/* </PermisosAcademico> */}
          <PermisosAdmin>
            <>
              <li className="nav-label mg-t-25">Gestión</li>
              <li
                className={
                  active === "emitir-comprobantes"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav(
                      "emitir-comprobantes",
                      "",
                      "emisión de comprobantes"
                    );
                    setActive("emitir-comprobantes");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z" />
                  </svg>
                  <span>Emisión de Comprobantes</span>
                </a>
              </li>
              <li
                className={
                  active === "recibos-ingreso" ? "nav-item active" : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("recibos-ingreso", "", "recibos de pago");
                    setActive("recibos-ingreso");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z" />
                  </svg>
                  <span>Recibos de Pago</span>
                </a>
              </li>
              <li
                className={
                  active === "proveedores" ? "nav-item active" : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("proveedores", "", "proveedores");
                    setActive("proveedores");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
                  </svg>
                  <span>Proveedores</span>
                </a>
              </li>
              <li
                className={
                  active === "cargar-comprobantes"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav(
                      "cargar-comprobantes",
                      "",
                      "carga de facturas proveedores"
                    );
                    setActive("cargar-comprobantes");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    x="0px"
                    y="0px"
                    width="24px"
                    height="24px"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <g id="Bounding_Box">
                      <rect fill="none" width="24" height="24" />
                    </g>
                    <g id="Flat">
                      <g id="ui_x5F_spec_x5F_header_copy_2"></g>
                      <g>
                        <path d="M17,19.22H5V7h7V5H5C3.9,5,3,5.9,3,7v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-7h-2V19.22z" />
                        <path d="M19,2h-2v3h-3c0.01,0.01,0,2,0,2h3v2.99c0.01,0.01,2,0,2,0V7h3V5h-3V2z" />
                        <rect x="7" y="9" width="8" height="2" />
                        <polygon points="7,12 7,14 15,14 15,12 12,12   " />
                        <rect x="7" y="15" width="8" height="2" />
                      </g>
                    </g>
                  </svg>
                  <span>Carga de Facturas</span>
                </a>
              </li>
              <li
                className={
                  active === "pagar-comprobantes"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("pagar-comprobantes", "", "pago de facturas");
                    setActive("pagar-comprobantes");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    x="0px"
                    y="0px"
                    width="24px"
                    height="24px"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      d="M0 0h24v24H0V0z"
                    />
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      d="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
                    />
                  </svg>
                  <span>Pago de Facturas</span>
                </a>
              </li>
              <li className="nav-label mg-t-25">Contabilidad</li>
              <li
                className={
                  active === "plan-cuentas" ? "nav-item active" : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("plan-cuentas", "", "plan de cuentas");
                    setActive("plan-cuentas");
                  }}
                >
                  {/* <i data-feather="book-open"></i> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z" />
                  </svg>
                  <span>Plan de Cuentas</span>
                </a>
              </li>
              <li
                className={
                  active === "asientos" ? "nav-item active" : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("asientos", "", "asientos");
                    setActive("asientos");
                  }}
                >
                  {/* <i data-feather="trello"></i> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path d="M13 7.5h5v2h-5zm0 7h5v2h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM11 6H6v5h5V6zm-1 4H7V7h3v3zm1 3H6v5h5v-5zm-1 4H7v-3h3v3z" />
                  </svg>
                  <span>Asientos</span>
                </a>
              </li>
              <li
                className={
                  active === "balances" ? "nav-item active" : "nav-item"
                }
              >
                <a
                  href="#"
                  className="nav-link"
                  onClick={() => {
                    menu.linkNav("balances", "", "balances");
                    setActive("balances");
                  }}
                >
                  {/* <i data-feather="briefcase"></i> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 22 22"
                    fill="currentColor"
                  >
                    <path d="M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z" />
                  </svg>
                  <span>Balances</span>
                </a>
              </li>
            </>
          </PermisosAdmin>
        </ul>
      </div>
    </aside>
  );
}
